

























































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import QuickTable from "../../../../../components/table/table.vue";
@Component({
	name:'orgRegisterTable',
	components: {
		QuickTable
	}
})
export default class OrgRegisterTable extends AbpBase {
	initData:any = {
		showModal: false,
		formLoading: false,
		personnels: [],		// 人员信息
		user: {
			organization: {},
    		name: ''
		},
		formData: {
			id: null,
			leaderId: '',
			minorLeaderId: '',
			teamMembers: []
		},
		ruleValidate: {
			leaderId: [
				{ required: true, type: 'number', message: '请选择安全管理组织机构组长', trigger: 'change' }
			],
			minorLeaderId: [
				{ required: true, type: 'number', message: '请选择安全管理组织机构副组长', trigger: 'change' }
			],
			teamMembers: [
				{ required: true, type: 'array', message: '请选择安全管理组织机构所属成员', trigger: 'change' }
			]
		},
		columns: [
			{
				title: '部门（实体）',
				key: 'dep',
				render: (h:any, params:any) => {
					return h('span', params.row.belongDep ? params.row.belongDep.displayName : '');
				}				
			},
			{
				title: '组长',
				key: 'leader',
				render: (h:any, params:any) => {
					return h('span', params.row.leader ? params.row.leader.name : '');
				}
			},
			{
				title: '副组长',
				key: 'minorLeader',
				render: (h:any, params:any) => {
					return h('span', params.row.minorLeader ? params.row.minorLeader.name : '');
				}
			},
			{
				title: '成员',
				key: 'members'
			},
			{
				title: '操作',
				key: 'action',
				render: (h:any, params:any) => {
					return h('Button', {
						props: {
							type: 'success',
							size: 'small'
						},
						on: {
							click: () => {
								this.initData.formData.id = params.row.id;
								this.initData.formData.leaderId = params.row.leader.id;
								this.initData.formData.minorLeaderId = params.row.minorLeader.id;
								this.initData.formData.teamMembers = params.row.members.split(",");
								this.initData.showModal = true;
							}
						}
					}, '编辑');
				}
			}
		]
	}
    // 初始化
    init() {
    	// 获取所有人员信息
    	this.$store.dispatch('project/GetAllPersons').then(() => {
    		this.initData.personnels = this.$store.state.project.allPersons;
    	})
    	// 获取当前登录账户信息
    	this.$store.dispatch('session/init').then(() => {
    		this.initData.user = this.$store.state.session.user;
    	})
    }
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
            	let params:any = {
            		leaderId: this.initData.formData.leaderId,
            		minorLeaderId: this.initData.formData.minorLeaderId,
            		teamMembers: this.initData.formData.teamMembers
            	}
            	this.initData.formLoading = true;
            	if(this.initData.formData.id) {
            		params.id = this.initData.formData.id;
            		await Ajax.put('/api/services/app/SafetyBasic/UpdateOrganizationAsync', params).then((res:any)=>{
		                this.$Message.success('编辑成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}else{
            		await Ajax.post('/api/services/app/SafetyBasic/CreateOrganizationAsync', params).then((res:any)=>{
		                this.$Message.success('添加成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		this.initData.formData.id = null;
    		(this as any).$refs.form.resetFields();
    	}
    }
    mounted() {
    	this.init();
    }
}
